export const live = {
    zbz: "直播中",
    ljks: "立即開始",
    hmyzb: "您還沒有直播過哦~",
    zbyg: "直播預告",
    yjs: "已結束",
    jszb: "結束直播",
    gbzb: "關閉直播",
    jxzb: "繼續直播",
    bctp: "保存圖片",
    fxlj: "分享鏈接",
    zbydk: "直播已斷開，請稍後...",
    fh: "返 回",
    wjcdypsb: "未檢測到音頻設備",
    czsb: "Canvas操作失敗:",
    tpjzsb: "圖片加載失敗，請檢查URL是否正確且圖片可訪問",
    zbjl: "直播記錄",
    sqjl: "申請記錄",
    lts: "聊天室",
    ren: "人",
    gdcy: "更多成員",
    cy: "成員",
    jcjy: "解除禁言",
    jy: "禁言",
    qbjy: "全部禁言",
    zbjs: "直播介紹",
    srnr: "請輸入內容",
    tczbj: "您已被踢出直播間",
    qd: "確   定",
    zbjjjs: "您的直播10min後將自動結束！",
    zbsc: "直播時長：",
    ljgkrs: "累計觀看人數：",
    dzs: "點讚數：",
    zbjies: "直播結束",
    ybjy: "您已被禁言",
    jycg: "解言成功",
    jinycg: "禁言成功",
    qbjinycg: "全部禁言成功",
    qbjycg: "全部解言成功",
    cwzb: "成為主播",
    lxgzry: "請聯繫工作人員成為主播",
    lxfs: "聯繫方式",
    zb: "直播",
    xkt: "Biking小課堂",
    sqzb: "申請直播",
    bczbzt: "本場直播主題",
    srzt: "請輸入主題",
    bczbjj: "本場直播簡介",
    kbsj: "開播時間",
    xzrisj: "選擇日期時間",
    tishi: "提示",
    dksdzb: "該時間點有 1 場待開始的直播",
    cxsj: "持續時間",
    xzsc: "選擇時長",
    fmt: "封面圖",
    fmtbnwk: "封面圖不能為空",
    sc: "上傳",
    yssc: "最大10MB，請壓縮後上傳",
    sccct: "請上傳360*170 尺寸的圖",
    tjsq: "提交申請",
    tpcj: "圖片裁剪",
    tzcjwz: "調整裁剪框位置，選擇要保留的區域",
    scdtp: "上傳的圖片",
    yl: "預覽 (360×170)",
    cjtp: "裁剪圖片",
    quxiao: "取消",
    qsrzbjj: "請輸入本場直播簡介",
    qxzrq: "請選擇日期",
    qxzsc: "請選擇時長",
    kssjdydqsj: "開始時間必須大於當前時間",
    sctxtpdx: "上傳頭像圖片大小不能超過 10MB!",
    tjcg: "提交成功",
    jkshnr: "我們將盡快審核您的申請內容",
    hmysqgzb: "您還沒有申請直播過哦~",
    shz: "審核中",
    tongg: "通過",
    jujue: "拒絕",
    yugao: "預告",
    huifang: "回放",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/live/tw.js